import { render } from "./OpportunityView.vue?vue&type=template&id=0a93da32"
import script from "./OpportunityView.vue?vue&type=script&lang=js"
export * from "./OpportunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__